
import AdminLayout from "../../commponents/layout/adminLayout";
import { useEffect, useState } from "react";
import type { TableColumn } from "../../commponents/table/types";
import { Pencil, Trash2 } from "lucide-react";

import { createsales, deletesalesById, editsales, getSales, getsalesById } from "../../api/salesApi";
import Modal from "../../commponents/Modal";
import DataTable from "../../commponents/table/DataTable";
import { showConfirm, showError, showSuccess } from "../../utils/ alert";

interface Sales {
  id: number;
  name: string;
  phone: string;
  nik: string;
  email: string;
  address: string;
  emergency_contact: string;
  status: string;
}

interface SalesForm {
  name: string;
  phone: string;
  nik: string;
  email: string;
  address: string;
  emergency_contact: string;
   status: string;
}

export default function SalesList() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sales, setSales] = useState<Sales[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const initialForm: SalesForm = {
    name: "",
    phone: "",
    nik: "",
    email: "",
    address: "",
    emergency_contact: "",
    status: "",
  };

  const [form, setForm] = useState<SalesForm>(initialForm);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const columns: TableColumn<Sales>[] = [
    {
      key: "name",
      title: "Nama",
    },
    {
      key: "phone",
      title: "No. Telp",
    },
   
    {
      key: "email",
      title: "Email",
    },
    {
      key: "address",
      title: "Alamat",
    },
    {
      key: "emergency_contact",
      title: "Kontak Darurat",
    },

    {
      key: "id",
      title: "Action",
      render: (row) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleEdit(row.id)}
            className="rounded-lg bg-yellow-100 p-2 text-yellow-600 hover:bg-yellow-200">
            <Pencil size={18} />
          </button>

          <button
            onClick={() => handleDelete(row.id)}
            className="rounded-lg bg-red-100 p-2 text-red-600 hover:bg-red-200">
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];

  const fetchsales = async () => {
    try {
      setLoading(true);

      const response = await getSales({
        page: currentPage,
        limit: pageSize,
      });

      setSales(response.data.salesList);
      setTotalPages(response.data.pagination.totalPages);

      setTotalData(response.data.pagination.totalData);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchsales();
  }, [currentPage, pageSize]);

  useEffect(() => {
   
  }, [sales]);

  const handleSave = async () => {
    try {
      if (!form.name.trim()) {
        showError("Sales name is required");
        return;
      }

      if (isEdit && selectedId !== null) {
        await editsales(selectedId, {
          name: form.name,
          phone: form.phone,
          nik: form.nik,
          email: form.email,
          address: form.address,
          emergency_contact: form.emergency_contact,
          status: "Active",
        });

       await  showSuccess("sales updated successfully.");
      } else {
        await createsales({
          name: form.name,
          phone: form.phone,
          nik: form.nik,
          email: form.email,
          address: form.address,
          emergency_contact: form.emergency_contact,
          status: "Active",
        });

        await showSuccess("sales created successfully.");
      }

      await fetchsales();

      handleCloseModal();
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
      showError("Failed to save sales.");
    }
  };

  const handleEdit = async (id: number) => {
    try {
      const { data } = await getsalesById(id);

     setForm({
       name: data.data.name,
       phone: data.data.phone,
       nik: data.data.nik,
       email: data.data.email,
       address: data.data.address,
       emergency_contact: data.data.emergency_contact,
       status: data.data.status,
     });

      setSelectedId(id);
      setIsEdit(true);
      setOpenModal(true);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const confirmed = await showConfirm(
        "Are you sure you want to delete this sales?"
      );

      if (!confirmed) return;

      await deletesalesById(id);

      await fetchsales();

      await showSuccess("sales deleted successfully.");

      // fetchProducts(); // refresh list
    } catch (error) {
      showError("Failed", "Failed to deleted data.");
    
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setForm(initialForm);
    setSelectedId(null);
    setIsEdit(false);
  };

  const handleAdd = () => {
    setIsEdit(false);
    setSelectedId(null);
    setForm(initialForm);
    setOpenModal(true);
  };

  return (
    <AdminLayout>
      <div className="bg-white rounded-3xl p-6">
        <DataTable
          title="Sales List"
          columns={columns}
          data={sales}
          onAdd={handleAdd}
          showSearch={false}
          showFilter={false}
          pagination={{
            currentPage,
            totalPages,
            pageSize,
            onPageChange: setCurrentPage,
            onPageSizeChange: (size) => {
              setPageSize(size);
              setCurrentPage(1);
            },
          }}
        />

        <Modal
          open={openModal}
          title={isEdit ? "Edit Sales" : "Add Sales"}
          onClose={handleCloseModal}>
          <div className="space-y-4">
            {/* Sales Name */}
            <div>
              <label className="mb-2 block font-semibold">Sales Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter sales name"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>

            {/* Phone Number */}
            <div>
              <label className="mb-2 block font-semibold">Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Enter phone number"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>

            {/* NIK */}
            <div>
              <label className="mb-2 block font-semibold">NIK</label>
              <input
                type="text"
                name="nik"
                value={form.nik}
                onChange={handleChange}
                placeholder="Enter NIK"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>

            {/* Email */}
            <div>
              <label className="mb-2 block font-semibold">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>

            {/* Address */}
            <div>
              <label className="mb-2 block font-semibold">Address</label>
              <textarea
                name="address"
                value={form.address}
                onChange={handleChange}
                rows={3}
                placeholder="Enter address"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>

            {/* Emergency Contact */}
            <div>
              <label className="mb-2 block font-semibold">
                Emergency Contact
              </label>
              <input
                type="text"
                name="emergency_contact"
                value={form.emergency_contact}
                onChange={handleChange}
                placeholder="Enter emergency contact"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>

            {/* Action */}
            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={handleCloseModal}
                className="rounded-lg bg-gray-500 px-5 py-2 text-white hover:bg-gray-600">
                Cancel
              </button>

              <button
                onClick={handleSave}
                className="rounded-lg bg-blue-600 px-5 py-2 text-white hover:bg-blue-700">
                {isEdit ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </AdminLayout>
  );
}
  


